import { useTranslation } from "react-i18next";
import { PublicClinicShell } from "./components/PublicClinicShell";

type LegalDocumentPageProps = {
  docKey: "cookies" | "legal_notice";
  sectionCount: number;
};

const SEO_BY_DOC = {
  cookies: {
    path: "/cookie-policy",
    titleKey: "seo.cookies_title",
    descriptionKey: "seo.cookies_description",
  },
  legal_notice: {
    path: "/legal-notice",
    titleKey: "seo.legal_notice_title",
    descriptionKey: "seo.legal_notice_description",
  },
} as const;

export function LegalDocumentPage({
  docKey,
  sectionCount,
}: LegalDocumentPageProps) {
  const { t } = useTranslation(["landing"]);
  const prefix = `landing:${docKey}`;
  const seo = SEO_BY_DOC[docKey];

  return (
    <PublicClinicShell
      seo={{
        title: t(`landing:${seo.titleKey}`),
        description: t(`landing:${seo.descriptionKey}`),
        path: seo.path,
      }}
    >
      <main className="flex-grow max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold tracking-tight mb-2">
          {t(`${prefix}.title`)}
        </h1>
        <p className="text-sm text-muted-foreground mb-8">
          {t(`${prefix}.updated`)}
        </p>

        <div className="space-y-6 text-card-foreground/90 leading-relaxed text-justify">
          <p>{t(`${prefix}.intro`)}</p>

          {Array.from({ length: sectionCount }, (_, index) => {
            const section = index + 1;
            return (
              <div key={section}>
                <h2 className="text-xl font-semibold text-foreground pt-4">
                  {t(`${prefix}.section${section}_title`)}
                </h2>
                <p>{t(`${prefix}.section${section}_body`)}</p>
              </div>
            );
          })}
        </div>
      </main>
    </PublicClinicShell>
  );
}
